import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; 
import axios from 'axios';
import reportWebVitals from './reportWebVitals';
import Cookies from 'js-cookie';
const root = ReactDOM.createRoot(document.getElementById('root'));
// axios.defaults.baseURL = "https://devadmin.smartinvestordeck.ai/qxbox/"; // Dev
axios.defaults.baseURL = "https://qa.smartinvestordeck.ai/api/"; // Dev

const token = Cookies.get("admin_user_token");
if(token){
  axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }
}
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
